import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DotsThree } from '@phosphor-icons/react'

import Icon from '../Icons'
export class DropdownDots extends Component {
  wrapperRef = React.createRef()

  state = {
    opened: false,
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ opened: false })
    }
  }

  toggleOpenDropdown = (e) => {
    e.stopPropagation()
    if (this.state.opened) {
      this.setState({ opened: false })
    } else {
      this.setState({ opened: true })
    }
  }

  handleClickAction = (e, action) => {
    if (action) {
      action(e)
      this.toggleOpenDropdown(e)
    } else {
      e.stopPropagation()
    }
  }

  render() {
    return (
      <div
        ref={(ref) => (this.wrapperRef = ref)}
        className="dropdown-dots"
        style={this.props.style}
        onClick={this.toggleOpenDropdown}
      >
        <div className="icon-container" style={this.props.label ? { width: 'auto' } : {}}>
          {this.props.label ? (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
              <span style={{ marginRight: 10 }}>{this.props.label}</span>
              <DotsThree size={20} weight="bold" />
            </div>
          ) : (
            <DotsThree size={20} weight="bold" />
          )}
        </div>
        <div className={`options-container ${this.state.opened ? 'open' : 'close'}`}>
          {this.props.options.map((item) => {
            return (
              <div
                key={item.id}
                className={`single-option-container ${
                  !item.action ? 'is-disabled' : ''
                } ${item.optionClassName || ''}`}
                onClick={(e) => this.handleClickAction(e, item.action)}
                style={item.styleContainer}
              >
                {item.icon ? (
                  <div className="icon-container">
                    <Icon icon={item.icon} {...item.iconStyles} />
                  </div>
                ) : null}
                <div className="single-option-text" style={item.styleText}>
                  {item.text}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

DropdownDots.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
      icon: PropTypes.string,
      iconStyles: PropTypes.object,
      isDisabled: PropTypes.bool,
      action: PropTypes.func,
      styleContainer: PropTypes.object,
      styleText: PropTypes.object,
    }),
  ).isRequired,
  style: PropTypes.object,
}

export default DropdownDots
